import { notification } from "antd";

const notificationService = {
    success,
    error,
    warning,
    info
};

// Helper function to normalize arguments (supports both object and string formats)
function normalizeArgs(messageOrObj, description) {
    if (typeof messageOrObj === 'object' && messageOrObj !== null) {
        return {
            message: messageOrObj.message || "",
            description: messageOrObj.description || ""
        };
    }
    return {
        message: messageOrObj || "",
        description: description || ""
    };
}

function success(messageOrObj = "", description = "") {
    const { message, description: desc } = normalizeArgs(messageOrObj, description);
    notification.success({
        message,
        description: desc
    });
}

function error(messageOrObj = "", description = "") {
    const { message, description: desc } = normalizeArgs(messageOrObj, description);
    notification.error({
        message,
        description: desc
    });
}

function warning(messageOrObj = "", description = "") {
    const { message, description: desc } = normalizeArgs(messageOrObj, description);
    notification.warning({
        message,
        description: desc
    });
}

function info(messageOrObj = "", description = "") {
    const { message, description: desc } = normalizeArgs(messageOrObj, description);
    notification.info({
        message,
        description: desc
    });
}

export default notificationService;
